import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Card} from 'semantic-ui-react';
import {Actions} from '../../actions';
import Header from '../internalCommons/header';
import {createOrderScreens} from '../../constants/internalScreens';
import OriginEdit from './originsEdit';
import OriginsTable from './originsTable';

const ManageOrdersParams = (props) => {
  const [originsCount, setOriginsCount] = useState(0);
  useEffect(() => {
    props.fetchOrigins();
  }, []);

  const handleChange = (value) => {
    setOriginsCount(value);
  };

  return (
    <>
      <Header screen={createOrderScreens.parameters} title={'Editar orígen'} />
      <Card raised fluid>
        {props.activeOrigin === null ?
          <OriginsTable
            dataTable={props.listOrigins}
            loading={props.loading}
            countRows={originsCount}
            handleChange={handleChange}
          /> :
          <OriginEdit />
        }
      </Card>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    'loading': state.manageOrders.loading,
    'listOrigins': state.manageOrders.listOrigins,
    'activeOrigin': state.manageOrders.activeOrigin,
  };
};

const {fetchOrigins} = Actions;

export default connect(mapStateToProps, {
  fetchOrigins,
})(ManageOrdersParams);
